import React, { useEffect, useState } from 'react';
import styles from './SignUpWizard.module.scss';
import { Col, Row } from 'reactstrap';
import classnames from 'classnames';
import Header from './Header/Header.lazy';
import { StepItemsInterface } from '../../interfaces/Steps.model';
import StepCompany from './StepCompany/StepCompany.lazy';
import StepUnits from './StepUnits/StepUnits.lazy';
import StepRules from './StepRules/StepRules.lazy';
import StepRulesLite from './StepRulesLite/StepRulesLite.lazy';
import StepLogin from './StepLogin/StepLogin.lazy';
import StepSettingUp from './StepSettingUp/StepSettingUp.lazy';
import { useNavigate } from 'react-router-dom';
import { User } from '../../interfaces/user.model';

const SignUpWizard = (props: any) => {
  /**
   * active step holds the step the user has made the most progress up to
   */
  const [activeStep, setActiveStep] = useState<number>(props.step);
  //visible step shows the current visible step
  const [visibleStep, setVisibleStep] = useState<number>(activeStep);
  // for example, a user may have got as far as step 3, but is viewing step 1 to make amendments
  // in this instance activeStep = 3, visibleStep = 1.
  const navigate = useNavigate();

  const changeStep = (direction: string | undefined) => {
    if (typeof direction === 'undefined') {
      direction = 'forward';
    }

    let goToStep: number;

    const routeType =
      props.user.accountMode === 0 ? cLSignupSteps : liteSignupSteps;

    // If you're on the login step and it's lite, we need to go back one more step.

    //the next step cannot be more than the signup length
    //if it is, just set it to the final step
    //otherwise increment by one.

    if (direction === 'forward') {
      goToStep =
        activeStep + 1 > routeType.length ? routeType.length : activeStep + 1;
    } else {
      // Special case: On final step in Lite flow, go back two steps skipping the uploading step.
      if (props.user.accountMode === 1 && activeStep === routeType.length) {
        goToStep = activeStep - 2 < 0 ? 0 : activeStep - 2;
      } else {
        goToStep = activeStep - 1 < 0 ? 0 : activeStep - 1;
      }
    }
    // console.log(activeStep,goToStep,direction)
    // let history = useHistory();
    // navigate(`/signup/${props.user.token}/${nextStep}`)
    setActiveStep(goToStep);
    setVisibleStep(goToStep);

    //added due to complaints from users in testing that on small screens
    //the form wasn't reverting to top of page
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const setUser = (data: User) => {
    props.setUser(data);
  };

  const setStep = (index: number) => {
    setVisibleStep(index);
  };

  //always run this on load
  useEffect(() => {
    if (typeof props.step !== 'undefined') {
      setVisibleStep(Number(props.step));
    }
  }, [props.step]);

  /**
   * what are the names and order of the steps?
   */
  let cLSignupSteps: StepItemsInterface = [
    {
      name: 'Your Details',
      component: (
        <StepCompany
          user={props.user}
          changeStep={changeStep}
          setUser={setUser}
        />
      ),
    },
    {
      name: 'Your Campsite',
      component: (
        <StepRules
          user={props.user}
          changeStep={changeStep}
          setUser={setUser}
        />
      ),
    },
  ];
  let liteSignupSteps: StepItemsInterface = [
    {
      name: 'Your Details',
      component: (
        <StepCompany
          user={props.user}
          changeStep={changeStep}
          setUser={setUser}
        />
      ),
    },
    {
      name: 'Your Business',
      component: (
        <StepRulesLite
          user={props.user}
          changeStep={changeStep}
          setUser={setUser}
        />
      ),
    },
    {
      name: 'Setting Up',
      component: (
        <StepSettingUp
          user={props.user}
          changeStep={changeStep}
          setUser={setUser}
        />
      ),
    },
    {
      name: 'Login Details',
      component: (
        <StepLogin
          user={props.user}
          changeStep={changeStep}
          setUser={setUser}
        />
      ),
    },
  ];

  let ruleData = props.user?.data?.rules;

  if (props.user.accountMode === 0) {
    if (
      typeof ruleData === 'undefined' ||
      (ruleData.pitchesQtyGrass === '0' &&
        ruleData.pitchesQtyHardStanding === '0')
    ) {
      cLSignupSteps.push({
        name: 'Pitches & Pricing',
        component: (
          <StepUnits
            user={props.user}
            changeStep={changeStep}
            setUser={setUser}
          />
        ),
      });
    } else {
      if (ruleData.pitchesQtyHardStanding > 0) {
        cLSignupSteps.push({
          name: 'Hardstanding Pricing',
          component: (
            <StepUnits
              user={props.user}
              changeStep={changeStep}
              setUser={setUser}
              type={'Hardstanding'}
            />
          ),
        });
      }

      if (ruleData.pitchesQtyGrass > 0) {
        cLSignupSteps.push({
          name: 'Grass Pitch Pricing',
          component: (
            <StepUnits
              user={props.user}
              changeStep={changeStep}
              setUser={setUser}
              type={'Grass'}
            />
          ),
        });
      }
    }
  }

  cLSignupSteps.push({
    name: 'Login Details',
    component: (
      <StepLogin user={props.user} changeStep={changeStep} setUser={setUser} />
    ),
  });

  console.log(cLSignupSteps, cLSignupSteps[visibleStep - 1]);

  const routeType =
    props.user.accountMode === 0 ? cLSignupSteps : liteSignupSteps;

  return (
    <>
      <div
        className={classnames(styles.SignUpWizard, 'grid-container')}
        data-testid='SignUpForm'
      >
        {/* the steps header at the top of the form*/}
        <Header
          items={routeType}
          active={visibleStep}
          clickableSteps={activeStep}
          setStep={setStep}
          setActiveStep={setActiveStep}
        />

        {/* render the current visible step's component */}
        {routeType[visibleStep - 1].component}
      </div>
    </>
  );
};

export default SignUpWizard;
